// angular
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot } from '@angular/router';

// module
import { AuthService } from '@shared/auth/auth.service';

//Permette l'accesso ai soli utenti autenticati
@Injectable()
export class AuthGuard  {
  constructor(private readonly _authService: AuthService,
              private readonly router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const url = state.url;

    return this.handleAuth(url);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  canLoad(route: Route): boolean {
    const url = `/${route.path}`;

    return this.handleAuth(url);
  }

  private handleAuth(url: string): boolean {
    if (this._authService.isAuthenticated) {
      return true;
    }

    this.router.navigate(['login'], { queryParams: {returl: url}});

    return false;
  }
}
